import { render } from "./Index.vue?vue&type=template&id=7628cfb2"
const script = {}
script.render = render

export default script